import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

import { toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import Indent from '../../components/Indent';
import Container from '../../components/Container';
import BigText from '../../components/BigText';
import Triplet from '../../components/Triplet';
import Title from '../../components/Title';
import Scene from '../Scene';
import Carousel from './components/Carousel/';
import Services from './components/Services';
import { FONT_SIZE_LARGE } from '../../constants';
import mq from '@/utils/media-queries';
import PreviewNextPage from '../../components/PreviewNextPage';
import isEmpty from 'lodash/isEmpty';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const SCENE_PADDING_TOP = 288;

const ApproachScene = styled(Scene)`
  padding-top: ${toVw(SCENE_PADDING_TOP)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(SCENE_PADDING_TOP)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(300)};
  `)};
`;

const StyledTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: ${toVw(174)};
  font-size: ${toVw(FONT_SIZE_LARGE)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(168)};
    font-size: ${toVwTablet(FONT_SIZE_LARGE)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(297)};
    font-size: ${toVwMobile(64)};
  `)};
`;

const Preface = styled(BigText)`
  margin-bottom: ${toVw(162)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(180)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(80)};
  `)};
`;

const TRIPLET_MARGIN_BOTTOM = 178;

const StyledTriplet = styled(Triplet)`
  margin-bottom: ${toVw(TRIPLET_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(TRIPLET_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(80)};
  `)};
`;

const Text = styled(BigText)`
  margin-bottom: ${toVw(196)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(162)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(180)};
  `)};
`;

const CAROUSEL_MARGIN_BOTTOM = 180;

const StyledCarousel = styled(Carousel)`
  margin-bottom: ${toVw(CAROUSEL_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(CAROUSEL_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(CAROUSEL_MARGIN_BOTTOM)};
  `)};
`;

class Approach extends React.Component {
  static propTypes = {
    approachStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.approachStore.load();
  }

  render() {
    const { approachStore, ...rest } = this.props;

    const { imageBlock, services, nextPreview } = approachStore.toJSON();

    return (
      <ApproachScene dark {...rest}>
        <Container>
          <Indent>
            <AnimationOnPageLoadItem>
              <StyledTitle>
                Детальный анализ <br /> в основе ярких идей
              </StyledTitle>
            </AnimationOnPageLoadItem>
            <AnimationOnPageLoadItem>
              <Preface>
                Приступая к проекту, мы исследуем внутренний мир компании-клиента, потребности аудитории и тенденции рынка.
              </Preface>
            </AnimationOnPageLoadItem>
          </Indent>
          {!isEmpty(imageBlock) && <StyledTriplet main={imageBlock.main} thumbs={imageBlock.thumbs} />}
          <Indent>
            <Text>Это помогает нам создавать прочную эмоциональную связь между брендом и людьми.</Text>
          </Indent>
          <StyledCarousel />
          {services &&
            services.length > 0 && (
              <Indent>
                <Services items={services} />
              </Indent>
            )}
        </Container>
        {nextPreview && <PreviewNextPage {...nextPreview} />}
      </ApproachScene>
    );
  }
}

export default inject(stores => ({ approachStore: stores.store.approachStore }))(observer(Approach));



// WEBPACK FOOTER //
// ./src/scenes/Approach/index.js